<script>
import {  common } from '@/mixins/common';

export default {
  name: 'DisplayLabelPreviewDialog',
  components: {},
  props: {
    displayDialog: {
      type: Boolean,
      required: true
    },
    order: {
      type: Object,
      required: true,
      default() {
        return {
          shipmentTrackingNumber: ''
        }
      }
    },
    data: {
      type: Array,
      required: true,
      default() {
        return []
      }
    }
  },
  data() {
    return {
      form: {
          trackingNumber: ''
      },
      currentShippingLabelUrl: ''
    }
  },
  mixins: [
    common
  ],
  methods: {
    downloadLabel() {
      const _vm = this
      window.open(_vm.currentShippingLabelUrl, '_blank').focus();
    },
    handleDialogClose() {
      this.$root.$emit('close-dialog', 'displayLabelPreviewDialog')
    }
  },
  watch: {
    'order.shipmentTrackingNumber': function (val) {
        this.form.trackingNumber = val
    },
    'form.trackingNumber': function (val) {
        const findShipment = this.data.find(v => v.trackingNumber == val)
        if (findShipment)
            this.currentShippingLabelUrl = findShipment.label
    }
  }
}
</script>

<template>
    <el-dialog
      custom-class="el-dialog-bs-info el-dialog-label-preview"
      :visible.sync="displayDialog"
      width="30%"
      @close="handleDialogClose">
      <span slot="title"><h5><i class="fas fa-sticky-note"></i> LABEL PREVIEW</h5></span>
        <div class="mb-2 text-center">
            <el-select
                v-model="form.trackingNumber"
                placeholder=""
                style="width: 100%">
                <el-option
                    v-for="dt in data"
                    :key="dt.id"
                    :label="dt.trackingNumber"
                    :value="dt.trackingNumber">
                </el-option>
            </el-select>
        </div>
        <div class="">
            <b-carousel
            style="text-shadow: 0px 0px 2px #000;"
            no-animation>
                <b-carousel-slide
                    :img-src="currentShippingLabelUrl"
                    id="product-attachment-0"
                    ></b-carousel-slide>
            </b-carousel>
        </div>
      <span slot="footer" class="dialog-footer text-center pb-0">
        <el-button
          @click="downloadLabel()"
          type="danger"
          class="mb-1">DOWNLOAD</el-button>
      </span>
    </el-dialog>
</template>

<style>
  [id^=product-attachment-] img {
    max-height: 70vh !important;
    max-width: 100% !important;
    width: auto !important;
    margin: auto;
  }
  [id^=product-attachment-] {
    text-align: center !important;
  }
  .carousel-caption .btn-group {
    z-index: 10000;
  }
    .el-dialog-label-preview {
        margin-top: 3vh !important;
    }
</style>
